import defprotocol from '../defprotocol'
import Function from '../types/Function'

const Sliceable = defprotocol({
  slice: Function
})

export default Sliceable
